module.exports = __webpack_public_path__ + "static/media/subscription2.7362f5ef.jpg";